/* =======================================================
   Islands of Loom — PDP JavaScript
   File: assets/pdp.js
   Loaded by: sections/pdp-main.liquid (deferred)

   This file handles:
   - Gallery image switching
   - Colour swatch redirect (separate products)
   - Size selection + low-stock indicator
   - Add to cart / Buy it now
   - Dispatch countdown (IST cutoff logic)
   - Delhivery pincode ETA check
   - Size guide modal
   - Accordion open/close
   - Mobile sticky bar
   - Toast notifications
   - Product recommendations
   ======================================================= */

(function () {
  'use strict';

  // Shared flag: true briefly after a real swipe gesture, so click handlers
  // (like image-zoom) can ignore the "ghost click" that follows a swipe on touch devices.
  var gallerySwipeJustHappened = false;

  function toIST(date) {
    return new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  }

  function getDispatchDate(now) {
    const ist  = toIST(now);
    const day  = ist.getDay();
    const h    = ist.getHours();
    const m    = ist.getMinutes();
    const beforeCutoff = h < 13 || (h === 13 && m === 0);
    const d = new Date(ist);
    if (day === 0) {
      d.setDate(d.getDate() + 1);
    } else if (day === 6 && !beforeCutoff) {
      d.setDate(d.getDate() + 2);
    } else if (!beforeCutoff) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function updateDispatch() {
    const el = document.getElementById('pdp-dispatch-line');
    if (!el) return;
    const now    = new Date();
    const ist    = toIST(now);
    const dispatch = getDispatchDate(now);
    const DAYS   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const isToday = dispatch.getDate()  === ist.getDate() &&
                    dispatch.getMonth() === ist.getMonth();
    const tomorrow = new Date(ist);
    tomorrow.setDate(ist.getDate() + 1);
    const isTomorrow = dispatch.getDate()     === tomorrow.getDate() &&
                       dispatch.getMonth()    === tomorrow.getMonth() &&
                       dispatch.getFullYear() === tomorrow.getFullYear();
    const label = isToday ? 'today' : isTomorrow ? 'tomorrow' : 'on ' + DAYS[dispatch.getDay()];
    // Countdown to 1pm on the dispatch day
    const cutoff = new Date(dispatch);
    cutoff.setHours(13, 0, 0, 0);
    // If dispatch is today and we're past 1pm, count to tomorrow's cutoff
    if (isToday && ist >= cutoff) cutoff.setDate(cutoff.getDate() + 1);
    const diff = Math.max(0, cutoff - ist);
    const pad  = n => String(n).padStart(2, '0');
    const hh   = Math.floor(diff / 3.6e6);
    const mm   = Math.floor((diff % 3.6e6) / 6e4);
    var newHtml = 'Order in the next <strong>' + hh + 'h ' + pad(mm) + 'm</strong> — dispatches ' + label;
    if (el.innerHTML !== newHtml) el.innerHTML = newHtml;
  }

  function checkPincode() {
    const input  = document.getElementById('pdp-pincode-input');
    const result = document.getElementById('pdp-pincode-result');
    if (!input || !result) return;
    const pin = input.value.trim();
    if (!/^\d{6}$/.test(pin)) {
      result.className = 'pincode-result show err';
      result.textContent = 'Please enter a valid 6-digit pincode.';
      return;
    }
    result.className = 'pincode-result show';
    result.textContent = 'Checking…';
    setTimeout(function () {
      const serviceable = ['1','4','5','6'].includes(pin[0]);
      renderPincodeResult({ serviceable: serviceable, eta_days: serviceable ? 2 : 5 }, pin, result);
    }, 800);
  }

  function renderPincodeResult(data, pin, resultEl) {
    const dispatch = getDispatchDate(new Date());
    const eta = new Date(dispatch);
    eta.setDate(eta.getDate() + (data.eta_days || 3));
    const DAYS   = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
    const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    if (data.serviceable) {
      resultEl.className = 'pincode-result show ok';
      resultEl.innerHTML = `<strong>Delivers by ${DAYS[eta.getDay()]}, ${eta.getDate()} ${MONTHS[eta.getMonth()]}</strong>`;
    } else {
      resultEl.className = 'pincode-result show err';
      resultEl.textContent = `Delivery to ${pin} is not available yet.`;
    }
  }

  function initSizes() {
    const btns = document.querySelectorAll('.size-btn');
    btns.forEach(function (btn) {
      if (btn.classList.contains('is-soldout')) return;
      btn.addEventListener('click', function () {
        btns.forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        const label = btn.dataset.size;
        const stock = parseInt(btn.dataset.stock, 10);
        const pickedEl = document.getElementById('pdp-size-picked');
        const mbSizeEl = document.getElementById('pdp-mb-size');
        const lowEl    = document.getElementById('pdp-low-stock');
        if (pickedEl) pickedEl.textContent = ' · ' + label;
        if (mbSizeEl) mbSizeEl.textContent  = 'Size ' + label + ' ›';
        if (lowEl) {
          lowEl.innerHTML = (stock > 0 && stock <= 3)
            ? `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M12 8v5M12 16.5v.5"/><circle cx="12" cy="12" r="9"/></svg> Only ${stock} left in ${label}`
            : '';
        }
        var variantInput = document.getElementById('pdp-variant-id');
        if (variantInput) variantInput.value = btn.dataset.variantId || '';
        var nativeInput = document.getElementById('pdp-native-variant-id');
        if (nativeInput) nativeInput.value = btn.dataset.variantId || '';
      });
    });
    var firstAvailable = document.querySelector('.size-btn:not(.is-soldout)');
    if (firstAvailable) firstAvailable.click();
  }

  function initGallery() {
    const thumbs  = document.querySelectorAll('.thumb');
    const mainImg = document.getElementById('pdp-main-image');
    const capEl   = document.getElementById('pdp-gallery-cap');

    function selectThumb(index) {
      var thumb = thumbs[index];
      if (!thumb) return;
      thumbs.forEach(t => t.setAttribute('aria-selected', 'false'));
      thumb.setAttribute('aria-selected', 'true');
      if (mainImg) {
        mainImg.src = thumb.dataset.fullSrc || '';
        mainImg.alt = thumb.dataset.alt || '';
        // Keep width/height in sync with each image's natural ratio so the
        // browser can reserve the right box size and avoid a layout jump —
        // gallery images are no longer force-cropped to one fixed ratio.
        if (thumb.dataset.fullW) mainImg.setAttribute('width', thumb.dataset.fullW);
        if (thumb.dataset.fullH) mainImg.setAttribute('height', thumb.dataset.fullH);
      }
      if (capEl) capEl.textContent = thumb.dataset.caption || '';
    }

    function getCurrentIndex() {
      return Array.from(thumbs).findIndex(t => t.getAttribute('aria-selected') === 'true');
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { selectThumb(i); });
    });

    // Arrow buttons
    var galleryMain = document.querySelector('.gallery-main');
    if (galleryMain && thumbs.length > 1) {
      var prevBtn = document.createElement('button');
      prevBtn.className = 'gallery-arrow gallery-arrow--prev';
      prevBtn.setAttribute('aria-label', 'Previous image');
      prevBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
      var nextBtn = document.createElement('button');
      nextBtn.className = 'gallery-arrow gallery-arrow--next';
      nextBtn.setAttribute('aria-label', 'Next image');
      nextBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      galleryMain.appendChild(prevBtn);
      galleryMain.appendChild(nextBtn);
      prevBtn.addEventListener('click', function() {
        var i = getCurrentIndex();
        selectThumb(i <= 0 ? thumbs.length - 1 : i - 1);
      });
      nextBtn.addEventListener('click', function() {
        var i = getCurrentIndex();
        selectThumb(i >= thumbs.length - 1 ? 0 : i + 1);
      });
    }

    // Touch swipe on main image — only horizontal swipes, vertical scrolls pass through
    if (galleryMain) {
      var touchStartX = 0;
      var touchEndX   = 0;
      var touchStartY = 0;
      var isPinch     = false;
      var isSwiping   = false;
      galleryMain.addEventListener('touchstart', function(e) {
        isPinch = e.touches.length > 1;
        if (isPinch) return;
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isSwiping = false;
      }, { passive: true });
      galleryMain.addEventListener('touchmove', function(e) {
        if (e.touches.length > 1) { isPinch = true; return; }
        var dx = Math.abs(e.changedTouches[0].screenX - touchStartX);
        var dy = Math.abs(e.changedTouches[0].screenY - touchStartY);
        if (dx > dy && dx > 10) isSwiping = true;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function(e) {
        if (isPinch) { isPinch = false; return; }
        if (!isSwiping) return;
        touchEndX = e.changedTouches[0].screenX;
        var diffX = touchStartX - touchEndX;
        var diffY = Math.abs(touchStartY - e.changedTouches[0].screenY);
        if (Math.abs(diffX) < 40 || diffY > Math.abs(diffX)) return;
        var i = getCurrentIndex();
        if (i === -1) i = 0;
        if (diffX > 0) {
          selectThumb(Math.min(i + 1, thumbs.length - 1));
        } else {
          selectThumb(Math.max(i - 1, 0));
        }
        // Mark that this was a real swipe so the click-to-zoom handler
        // on the main image ignores the ghost click that follows.
        gallerySwipeJustHappened = true;
        setTimeout(function () { gallerySwipeJustHappened = false; }, 400);
      }, { passive: true });
    }
  }

  function getSelectedVariantId() {
    var el = document.getElementById('pdp-variant-id');
    var val = el ? el.value.trim() : '';
    return (val && val !== '0') ? val : null;
  }

  function addToCart() {
    const variantId = getSelectedVariantId();
    if (!variantId) {
      ping('Please select a size first');
      const sizeBlock = document.getElementById('pdp-size-block');
      if (sizeBlock) sizeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const btn = document.getElementById('pdp-add-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(function (r) {
      if (!r.ok) return handleCartError(r, btn);
      return r.json().then(function (item) {
        if (btn) {
          btn.classList.add('is-added');
          btn.innerHTML = `<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg> Added to cart`;
        }
        updateCartCount();
        fetch('/?sections=cart-drawer')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            var html = data['cart-drawer'];
            if (html) {
              var target = document.querySelector('#cartDrawer');
              if (target) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(html, 'text/html');
                var newContent = doc.querySelector('#cartDrawer');
                if (newContent) {
                  target.innerHTML = newContent.innerHTML;
                  if (window.Shopify && window.Shopify.PaymentButton) {
                    window.Shopify.PaymentButton.init();
                  }
                }
              }
            }
            var cartTrigger = document.querySelector('.js-header-cart-status-btn');
            if (cartTrigger) cartTrigger.click();
          })
          .catch(function() {
            var cartTrigger = document.querySelector('.js-header-cart-status-btn');
            if (cartTrigger) cartTrigger.click();
          });
        setTimeout(function () {
          if (btn) { btn.classList.remove('is-added'); btn.disabled = false; btn.textContent = 'Add to cart'; }
        }, 2200);
      });
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
      ping('Something went wrong. Please try again.');
    });
  }

  function handleCartError(r, btn) {
    return r.json().then(function (data) {
      if (btn) { btn.disabled = false; btn.textContent = 'Add to cart'; }
      var msg = (data && data.description) || 'Something went wrong. Please try again.';
      if (msg.toLowerCase().includes('maximum quantity')) {
        msg = 'This item is already in your cart.';
      }
      ping(msg);
    });
  }

  function buyNow() {
    const variantId = getSelectedVariantId();
    if (!variantId) {
      ping('Please select a size first');
      const sizeBlock = document.getElementById('pdp-size-block');
      if (sizeBlock) sizeBlock.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    const btn = document.getElementById('pdp-buy-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Redirecting…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      window.location.href = '/checkout';
    })
    .catch(function() {
      if (btn) { btn.disabled = false; btn.textContent = 'Buy it now'; }
      ping('Something went wrong. Please try again.');
    });
  }

  var BADGE_SELECTORS = [
    '[data-cart-count]',
    '.cart-count',
    '#cart-count',
    '.header__cart-count',
    '.cart-icon-bubble .visually-hidden',
    '[data-cart-item-count]',
    '.cart-badge',
  ];

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        BADGE_SELECTORS.forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) {
            if (el.hasAttribute('data-cart-count')) {
              el.setAttribute('data-cart-count', count);
            }
            el.textContent = count > 0 ? count : '';
            if (count > 0) {
              el.classList.add('show');
              el.removeAttribute('hidden');
              el.setAttribute('aria-hidden', 'false');
            }
          });
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {});
  }

  /* =====================================================
     PRODUCT RECOMMENDATIONS
     ===================================================== */
  function initRecommendations() {
    var grid = document.getElementById('pdp-recommendations');
    if (!grid) return;
    var productId = grid.dataset.productId;
    if (!productId) return;

    var section = document.getElementById('pdp-also-like');
    if (section) section.style.display = '';

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = data.products;
        if (products && products.length > 0) {
          renderAlsoLike(products, grid);
        } else {
          var collectionHandle = grid.dataset.collectionHandle;
          var fetchUrl = (collectionHandle && collectionHandle !== 'all')
            ? '/collections/' + collectionHandle + '/products.json?limit=20'
            : '/collections/all/products.json?limit=20';
          fetch(fetchUrl)
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var filtered = (d.products || []).filter(function (p) {
                return String(p.id) !== String(productId);
              }).slice(0, 4);
              if (filtered.length > 0) {
                renderAlsoLike(filtered, grid);
              } else {
                hideAlsoLike();
              }
            })
            .catch(hideAlsoLike);
        }
      })
      .catch(hideAlsoLike);
  }

  function hideAlsoLike() {
    var section = document.getElementById('pdp-also-like');
    if (section) section.style.display = 'none';
  }

  function renderAlsoLike(products, grid) {
    // Global sale-badge toggle, mirrored from `settings.show_sale_badge`
    // via a data attribute on the grid — this JS has no access to Liquid
    // theme settings otherwise, so if the merchant turns badges off in
    // the customizer, this attribute needs to reflect that too.
    var showSaleBadge = grid.dataset.showSaleBadge === 'true';

    var html = products.map(function (p) {
      var images = p.images || [];
      function getImageSrc(img) {
        if (!img) return '';
        if (typeof img === 'string') return img;
        return img.src || img.url || '';
      }
      var primaryImg = getImageSrc(images[0]);
      var secondaryImg = getImageSrc(images[1]);
      // FIXED: preserve ?v= query string when adding _600x600 size suffix
      if (primaryImg) {
        primaryImg = primaryImg.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, '_600x600.$1$2');
      }
      if (secondaryImg) {
        secondaryImg = secondaryImg.replace(/\.(jpg|jpeg|png|gif|webp)(\?|$)/i, '_600x600.$1$2');
      }
      var price = 0;
      var compareAtPrice = 0;
      if (typeof p.price_min === 'number') {
        price = p.price_min / 100;
        if (typeof p.compare_at_price_min === 'number') {
          compareAtPrice = p.compare_at_price_min / 100;
        }
      } else if (p.variants && p.variants.length) {
        var firstVariant = p.variants[0];
        price = parseFloat(firstVariant.price || 0);
        compareAtPrice = parseFloat(firstVariant.compare_at_price || 0);
      }
      var onSale = compareAtPrice > 0 && compareAtPrice > price;
      var priceHtml = onSale
        ? `<div class="al-price-wrap"><span class="al-price-sale">${price.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span><span class="al-price-compare">${compareAtPrice.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</span></div>`
        : `<div class="al-price">${price.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 })}</div>`;

      var available = typeof p.available !== 'undefined' ? p.available : (p.variants || []).some(function(v) { return v.available; });

      // Tags come back as a comma-separated string from both
      // /recommendations/products.json and /collections/x/products.json;
      // the array branch is a safety net in case that ever changes.
      var tagList = (typeof p.tags === 'string' ? p.tags : (p.tags || []).join(','))
        .toLowerCase()
        .split(',')
        .map(function (t) { return t.trim(); });

      // Mirrors the badge structure/classes in snippets/card-product.liquid
      // (badge / badge--sale / badge--oos / badge-text) so it inherits the
      // same theme CSS as the collection-grid and PDP-gallery badges,
      // instead of the old flat "Sale" tag.
      var badge = '';
      if (!available) {
        badge = '<div class="al-badge"><span class="badge badge--oos d-inline-block fw-700"><span class="d-inline-block badge-text">Sold Out</span></span></div>';
      } else if (onSale && showSaleBadge && tagList.indexOf('hide-sale-badge') === -1) {
        if (tagList.indexOf('last-pieces') !== -1) {
          badge = '<div class="al-badge"><span class="badge badge--sale d-inline-block fw-700"><span class="d-inline-block badge-text">Last Pieces</span></span></div>';
        } else {
          var saveAmount = compareAtPrice > 0 ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100) : 0;
          // NOTE: verify this text against the 'products.product.card.save_percent'
          // locale string used by card-product.liquid and adjust if it differs.
          badge = '<div class="al-badge"><span class="badge badge--sale d-inline-block fw-700"><span class="d-inline-block badge-text">Save ' + saveAmount + '%</span></span></div>';
        }
      }

      return `<a class="al-card" href="/products/${p.handle}"><div class="al-img">${badge}${primaryImg ? `<img class="al-img-primary" src="${primaryImg}" alt="${escHtml(p.title)}" loading="lazy" width="600" height="600">` : ''}${secondaryImg ? `<img class="al-img-secondary" src="${secondaryImg}" alt="${escHtml(p.title)}" loading="lazy" width="600" height="600">` : ''}</div><div class="al-name">${escHtml(p.title)}</div>${priceHtml}</a>`;
    }).join('');
    grid.innerHTML = html;
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* =====================================================
     READ MORE / LESS
     Description — all devices. Fabric story — mobile only.
     ===================================================== */
  function initReadMore() {
    [
      { wrap: 'pdp-desc-wrap',   btn: 'pdp-desc-toggle' },
      { wrap: 'pdp-fabric-wrap', btn: 'pdp-fabric-toggle' }
    ].forEach(function(pair) {
      var wrap = document.getElementById(pair.wrap);
      var btn  = document.getElementById(pair.btn);
      if (!wrap || !btn) return;
      if (btn.dataset.rmInit) return; // already initialized
      btn.dataset.rmInit = '1';
      var content = wrap.querySelector('.read-more-content');
      if (content && content.scrollHeight > 0 && content.scrollHeight <= 60) {
        wrap.classList.remove('is-collapsed');
        btn.style.display = 'none';
        return;
      }
      btn.addEventListener('click', function() {
        var collapsed = wrap.classList.contains('is-collapsed');
        wrap.classList.toggle('is-collapsed', !collapsed);
        btn.textContent = collapsed ? 'Read less' : 'Read more';
      });
    });
  }

  function initAccordions() {
    document.querySelectorAll('.acc-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var acc  = btn.closest('.acc');
        var open = acc.getAttribute('data-open') === 'true';
        acc.setAttribute('data-open', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  function openSizeGuide() {
    var modal = document.getElementById('pdp-size-modal');
    if (modal) { modal.style.display = 'flex'; document.body.style.overflow = 'hidden'; }
  }
  function closeSizeGuide() {
    var modal = document.getElementById('pdp-size-modal');
    if (modal) { modal.style.display = 'none'; document.body.style.overflow = ''; }
  }

  /* =====================================================
     MOBILE-SAFE SCROLL LOCK
     Plain `overflow:hidden` on <body> does not reliably stop
     scroll/rubber-banding on iOS Safari. Freezing body at its
     current scroll position with position:fixed is the safe
     cross-browser approach, and it's fully reversible.
     ===================================================== */
  var __zoomScrollY = 0;
  function lockBodyScroll() {
    __zoomScrollY = window.scrollY || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top   = '-' + __zoomScrollY + 'px';
    document.body.style.left  = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.classList.add('pdp-zoom-lock');
  }
  function unlockBodyScroll() {
    document.body.classList.remove('pdp-zoom-lock');
    document.body.style.position = '';
    document.body.style.top   = '';
    document.body.style.left  = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, __zoomScrollY);
  }

  function initImageZoom() {
    var galleryMain = document.querySelector('.gallery-main');
    var mainImg = document.getElementById('pdp-main-image');
    if (!galleryMain || !mainImg) return;

    // Collect all images from thumbs
    var thumbs = document.querySelectorAll('.thumb');
    var images = [];
    thumbs.forEach(function(thumb) {
      images.push({
        src: thumb.dataset.fullSrc || '',
        zoomSrc: thumb.dataset.zoomSrc || thumb.dataset.fullSrc || '',
        alt: thumb.dataset.alt || ''
      });
    });
    if (!images.length) return;

    mainImg.style.cursor = 'zoom-in';

    function getCurrentIndex() {
      return Array.from(thumbs).findIndex(function(t) {
        return t.getAttribute('aria-selected') === 'true';
      });
    }

    function openOverlay(startIndex) {
      var current = startIndex;

      var overlay = document.createElement('div');
      overlay.id = 'pdp-zoom-overlay';
      // Fullscreen fix: fixed top/left/width instead of `inset:0` shorthand,
      // z-index raised well above any theme header/cart-drawer/menu z-index,
      // and explicit 100vh + 100dvh height (dvh corrected live below) so the
      // overlay always matches the true visible viewport on mobile browsers.
      overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100vh;height:100dvh;z-index:9999;background:#F4EAD9;display:flex;flex-direction:column;align-items:center;justify-content:center;';

      // Close button
      var closeBtn = document.createElement('button');
      closeBtn.style.cssText = 'position:absolute;top:16px;right:16px;background:#223C1F;border:0;border-radius:50%;width:40px;height:40px;display:flex;align-items:center;justify-content:center;cursor:pointer;color:#F4EAD9;z-index:2;';
      closeBtn.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      overlay.appendChild(closeBtn);

      // Main image wrapper
      var imgWrap = document.createElement('div');
      // touch-action:none is required here — without it, mobile browsers can
      // intercept a two-finger gesture for native page-zoom before our JS
      // pinch handler ever reliably receives clean touch events, even with
      // preventDefault() called in touchmove.
      imgWrap.style.cssText = 'flex:1;width:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative;touch-action:none;';

      // width:100%/height:100% locks the image box to exactly match imgWrap,
      // so object-fit:contain can reliably show the full image (letterboxed
      // if needed, never cropped) without depending on the browser resolving
      // an auto-sizing shrink-to-fit calculation, which is what was causing
      // the top/bottom crop on some devices.
      var img = document.createElement('img');
      img.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;user-select:none;display:block;transform-origin:center center;transition:transform .25s;cursor:zoom-in;touch-action:none;';
      imgWrap.appendChild(img);
      overlay.appendChild(imgWrap);

      // Prev/Next arrows
      var prevBtn = document.createElement('button');
      prevBtn.style.cssText = 'position:absolute;left:12px;top:50%;transform:translateY(-50%);background:none;border:0;padding:10px;cursor:pointer;color:#223C1F;z-index:2;filter:drop-shadow(0 1px 4px rgba(0,0,0,.35));';
      prevBtn.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>';
      var nextBtn = document.createElement('button');
      nextBtn.style.cssText = 'position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;border:0;padding:10px;cursor:pointer;color:#223C1F;z-index:2;filter:drop-shadow(0 1px 4px rgba(0,0,0,.35));';
      nextBtn.innerHTML = '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 18l6-6-6-6"/></svg>';
      overlay.appendChild(prevBtn);
      overlay.appendChild(nextBtn);

      function preloadImage(src) {
        if (!src) return;
        var p = new Image();
        p.src = src;
      }

      // Warm the browser cache for the images on either side of `idx`, in both
      // qualities, so a swipe in either direction never hits an empty network fetch.
      function preloadNeighbors(idx) {
        var nextIdx = (idx + 1) % images.length;
        var prevIdx = (idx - 1 + images.length) % images.length;
        [nextIdx, prevIdx].forEach(function(i) {
          preloadImage(images[i].src);
          preloadImage(images[i].zoomSrc);
        });
      }

      // Swaps in the sharper zoom-quality image once it's actually downloaded,
      // without ever blocking on it — the cached fullSrc is shown in the meantime.
      function upgradeToZoomSrc(idx) {
        var zSrc = images[idx].zoomSrc;
        if (!zSrc || zSrc === images[idx].src) return;
        var pre = new Image();
        pre.onload = function() {
          if (current === idx) img.src = zSrc; // only apply if still viewing this image
        };
        pre.src = zSrc;
      }

      function goTo(index) {
        current = (index + images.length) % images.length;
        panX = 0;
        panY = 0;
        isZoomed = false;
        currentScale = 1;
        img.style.cursor = 'zoom-in';
        img.style.transition = 'transform .25s';
        applyTransform();
        img.src = images[current].src; // cached, loads instantly
        img.alt = images[current].alt;
        upgradeToZoomSrc(current);
        preloadNeighbors(current);
      }

      function closeOverlay() {
        if (overlay.__cleanupHeightListener) overlay.__cleanupHeightListener();
        overlay.remove();
        unlockBodyScroll();
        document.removeEventListener('keydown', onKey);
      }

      function onKey(e) {
        if (e.key === 'Escape') closeOverlay();
        if (e.key === 'ArrowRight') goTo(current + 1);
        if (e.key === 'ArrowLeft') goTo(current - 1);
      }

      closeBtn.addEventListener('click', closeOverlay);
      prevBtn.addEventListener('click', function() { goTo(current - 1); });
      nextBtn.addEventListener('click', function() { goTo(current + 1); });
      document.addEventListener('keydown', onKey);

      var swipeStartX    = 0;
      var swipeStartY    = 0;
      var swipeIsPinch   = false;
      var lastTap        = 0;
      var isZoomed       = false;
      var currentScale   = 1;      // continuous zoom level driven by pinch; double-tap jumps to ZOOM_SCALE
      var panX           = 0;
      var panY           = 0;
      var panStartX      = 0;
      var panStartY      = 0;
      var dragAxis       = null;   // 'x' | 'y' | null — locked in after the first ~8px of movement
      var peekImg        = null;   // the adjacent image, shown sliding in during a horizontal drag
      var pStrayEls      = [];     // peek images mid-way through their removal transition
      var touchStartTime = 0;

      // Pinch-zoom tracking
      var pinchStartDist  = 0;
      var pinchStartScale = 1;
      var pinchAnchorX    = 0;     // content point under the pinch center, in unscaled coords
      var pinchAnchorY    = 0;

      function pinchDistance(t0, t1) {
        var dx = t1.clientX - t0.clientX;
        var dy = t1.clientY - t0.clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      function pForceCleanup() {
        pStrayEls.forEach(function(entry) {
          clearTimeout(entry.timeoutId);
          if (entry.el.parentNode) entry.el.parentNode.removeChild(entry.el);
        });
        pStrayEls = [];
        if (peekImg && peekImg.parentNode) peekImg.parentNode.removeChild(peekImg);
        peekImg = null;
      }

      var ZOOM_SCALE = 2.5; // double-tap target scale
      var MIN_SCALE  = 1;
      var MAX_SCALE  = 4;   // pinch can go further than double-tap, supported by the higher-res zoomSrc images

      function applyTransform() {
        var scale = currentScale;
        img.style.transform = 'scale(' + scale + ') translate(' + (panX / scale) + 'px, ' + (panY / scale) + 'px)';
      }

      function handleTapOrDoubleTap() {
        var now = Date.now();
        var timeSinceLast = now - lastTap;
        if (timeSinceLast < 300 && timeSinceLast > 0) {
          isZoomed = !isZoomed;
          currentScale = isZoomed ? ZOOM_SCALE : 1;
          if (!isZoomed) { panX = 0; panY = 0; }
          img.style.cursor = isZoomed ? 'zoom-out' : 'zoom-in';
          img.style.transition = 'transform .25s';
          applyTransform();
          lastTap = 0;
        } else {
          lastTap = now;
        }
      }

      imgWrap.addEventListener('touchstart', function(e) {
        swipeIsPinch = e.touches.length > 1;
        if (swipeIsPinch) {
          if (e.touches.length === 2) {
            pForceCleanup();
            img.style.transition = 'none';
            pinchStartDist = pinchDistance(e.touches[0], e.touches[1]);
            pinchStartScale = currentScale;
            var rect = imgWrap.getBoundingClientRect();
            var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left - rect.width / 2;
            var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top - rect.height / 2;
            // Content point currently sitting under the pinch center, in
            // unscaled coordinates — kept fixed under the fingers as the
            // gesture progresses, computed once at gesture start.
            pinchAnchorX = (midX - panX) / pinchStartScale;
            pinchAnchorY = (midY - panY) / pinchStartScale;
          }
          return;
        }
        pForceCleanup();
        if (!isZoomed) {
          img.style.transition = 'none';
          img.style.transform = 'translateX(0px)';
          img.style.opacity = '1';
        }
        swipeStartX = e.changedTouches[0].screenX;
        swipeStartY = e.changedTouches[0].screenY;
        panStartX = swipeStartX;
        panStartY = swipeStartY;
        dragAxis = null;
        touchStartTime = Date.now();
      }, { passive: true });

      imgWrap.addEventListener('touchmove', function(e) {
        if (e.touches.length > 1) {
          e.preventDefault();
          swipeIsPinch = true;
          var dist = pinchDistance(e.touches[0], e.touches[1]);
          var rawScale = pinchStartScale * (dist / pinchStartDist);
          currentScale = Math.min(Math.max(rawScale, MIN_SCALE), MAX_SCALE);
          isZoomed = currentScale > 1.02;
          var rect = imgWrap.getBoundingClientRect();
          var midX = (e.touches[0].clientX + e.touches[1].clientX) / 2 - rect.left - rect.width / 2;
          var midY = (e.touches[0].clientY + e.touches[1].clientY) / 2 - rect.top - rect.height / 2;
          // Keep the same content point anchored under the pinch center
          panX = midX - pinchAnchorX * currentScale;
          panY = midY - pinchAnchorY * currentScale;
          img.style.cursor = isZoomed ? 'zoom-out' : 'zoom-in';
          applyTransform();
          return;
        }
        if (swipeIsPinch) return;

        var curX = e.changedTouches[0].screenX;
        var curY = e.changedTouches[0].screenY;

        // While zoomed, one-finger drag pans around the image (unchanged behaviour)
        if (isZoomed) {
          e.preventDefault();
          var pdx = curX - panStartX;
          var pdy = curY - panStartY;
          panX += pdx;
          panY += pdy;
          panStartX = curX;
          panStartY = curY;
          img.style.transition = 'none';
          applyTransform();
          return;
        }

        var totalDX = curX - swipeStartX;
        var totalDY = curY - swipeStartY;

        if (!dragAxis) {
          if (Math.abs(totalDX) < 8 && Math.abs(totalDY) < 8) return;
          dragAxis = Math.abs(totalDX) > Math.abs(totalDY) ? 'x' : 'y';
        }

        if (dragAxis === 'x') {
          e.preventDefault();
          if (!peekImg && Math.abs(totalDX) > 4) {
            var dir = totalDX > 0 ? -1 : 1; // dragging right → reveal prev, dragging left → reveal next
            var peekIndex = (current + dir + images.length) % images.length;
            peekImg = document.createElement('img');
            peekImg.src = images[peekIndex].src; // cached, fast — swipe preview doesn't need full zoom quality
            peekImg.style.cssText = img.style.cssText;
            peekImg.style.transition = 'none';
            peekImg.dataset.dir = dir;
            imgWrap.insertBefore(peekImg, img);
          }
          img.style.transition = 'none';
          img.style.transform = 'translateX(' + totalDX + 'px)';
          if (peekImg) {
            var dir2 = parseInt(peekImg.dataset.dir, 10);
            var wrapW = imgWrap.clientWidth;
            peekImg.style.transform = 'translateX(' + (totalDX + dir2 * wrapW) + 'px)';
          }
        } else {
          e.preventDefault();
          img.style.transition = 'none';
          img.style.transform = 'translateY(' + totalDY + 'px)';
          var progress = Math.min(Math.abs(totalDY) / 200, 1);
          img.style.opacity = String(1 - progress * 0.4);
          overlay.style.background = 'rgba(244,234,217,' + (1 - progress * 0.6) + ')';
        }
      }, { passive: false });

      imgWrap.addEventListener('touchend', function(e) {
        if (swipeIsPinch) {
          if (e.touches.length === 0) {
            swipeIsPinch = false;
            // Snap back cleanly if the pinch ended close to the un-zoomed state
            if (currentScale <= 1.05) {
              currentScale = 1;
              panX = 0;
              panY = 0;
              isZoomed = false;
              img.style.cursor = 'zoom-in';
              img.style.transition = 'transform .2s';
              applyTransform();
            } else {
              img.style.cursor = 'zoom-out';
            }
          }
          return;
        }

        if (isZoomed) { handleTapOrDoubleTap(); return; }

        var elapsed = Math.max(Date.now() - touchStartTime, 1);

        if (dragAxis === 'x') {
          var endX = e.changedTouches[0].screenX;
          var totalDX = endX - swipeStartX;
          var velocity = Math.abs(totalDX) / elapsed; // px per ms
          var wrapW = imgWrap.clientWidth;
          var shouldAdvance = Math.abs(totalDX) > wrapW * 0.22 || velocity > 0.5;

          if (shouldAdvance && peekImg) {
            var dir = parseInt(peekImg.dataset.dir, 10);
            var committedPeek = peekImg;
            peekImg = null;
            img.style.transition = 'transform .22s ease-out';
            committedPeek.style.transition = 'transform .22s ease-out';
            img.style.transform = 'translateX(' + (-dir * wrapW) + 'px)';
            committedPeek.style.transform = 'translateX(0px)';
            var pEntry = { el: committedPeek, timeoutId: null };
            pStrayEls.push(pEntry);
            pEntry.timeoutId = setTimeout(function() {
              current = (current + dir + images.length) % images.length;
              img.src = images[current].src; // same URL committedPeek was already showing — seamless
              img.alt = images[current].alt;

              function reveal() {
                if (pStrayEls.indexOf(pEntry) === -1) return; // a new gesture already cleaned this up
                img.style.transition = 'none';
                img.style.transform = 'translateX(0px)';
                img.style.cursor = 'zoom-in';
                upgradeToZoomSrc(current);
                preloadNeighbors(current);
                if (committedPeek.parentNode) committedPeek.parentNode.removeChild(committedPeek);
                pStrayEls = pStrayEls.filter(function(en) { return en !== pEntry; });
              }
              if (img.decode) {
                img.decode().then(reveal).catch(reveal);
              } else {
                reveal();
              }
            }, 220);
          } else {
            img.style.transition = 'transform .22s ease-out';
            img.style.transform = 'translateX(0px)';
            if (peekImg) {
              var d = parseInt(peekImg.dataset.dir, 10);
              var toRemove = peekImg;
              peekImg = null;
              toRemove.style.transition = 'transform .22s ease-out';
              toRemove.style.transform = 'translateX(' + (d * wrapW) + 'px)';
              var pEntry2 = { el: toRemove, timeoutId: null };
              pStrayEls.push(pEntry2);
              pEntry2.timeoutId = setTimeout(function() {
                if (toRemove.parentNode) toRemove.parentNode.removeChild(toRemove);
                pStrayEls = pStrayEls.filter(function(en) { return en !== pEntry2; });
              }, 220);
            }
          }
          dragAxis = null;
          return;
        }

        if (dragAxis === 'y') {
          var endY = e.changedTouches[0].screenY;
          var totalDY = endY - swipeStartY;
          var vVelocity = Math.abs(totalDY) / elapsed;

          if (Math.abs(totalDY) > 90 || vVelocity > 0.6) {
            img.style.transition = 'transform .22s ease-out, opacity .22s ease-out';
            img.style.transform = 'translateY(' + (totalDY > 0 ? window.innerHeight : -window.innerHeight) + 'px)';
            img.style.opacity = '0';
            overlay.style.transition = 'background .22s ease-out';
            overlay.style.background = 'rgba(244,234,217,0)';
            setTimeout(closeOverlay, 220);
          } else {
            img.style.transition = 'transform .22s ease-out, opacity .22s ease-out';
            img.style.transform = 'translateY(0px)';
            img.style.opacity = '1';
            overlay.style.transition = 'background .22s ease-out';
            overlay.style.background = '#F4EAD9';
          }
          dragAxis = null;
          return;
        }

        // No axis was locked in — this was a tap, not a drag
        handleTapOrDoubleTap();
      }, { passive: true });

      // Desktop: drag to pan while zoomed in
      var mouseIsDown  = false;
      var mouseDragged = false;
      var mouseStartX  = 0;
      var mouseStartY  = 0;

      imgWrap.addEventListener('mousedown', function(e) {
        if (!isZoomed) return;
        mouseIsDown = true;
        mouseDragged = false;
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
        img.style.transition = 'none';
        img.style.cursor = 'grabbing';
        e.preventDefault();
      });

      window.addEventListener('mousemove', function(e) {
        if (!mouseIsDown || !isZoomed) return;
        var dx = e.clientX - mouseStartX;
        var dy = e.clientY - mouseStartY;
        if (Math.abs(dx) > 3 || Math.abs(dy) > 3) mouseDragged = true;
        panX += dx;
        panY += dy;
        mouseStartX = e.clientX;
        mouseStartY = e.clientY;
        applyTransform();
      });

      window.addEventListener('mouseup', function() {
        if (!mouseIsDown) return;
        mouseIsDown = false;
        img.style.transition = 'transform .25s';
        img.style.cursor = isZoomed ? 'zoom-out' : 'zoom-in';
      });

      // Click to zoom on desktop — ignored if the click followed a drag
      img.addEventListener('click', function(e) {
        e.stopPropagation();
        if (mouseDragged) { mouseDragged = false; return; }
        if (isZoomed) {
          isZoomed = false;
          currentScale = 1;
          panX = 0;
          panY = 0;
          img.style.cursor = 'zoom-in';
          img.style.transition = 'transform .25s';
          applyTransform();
        } else {
          isZoomed = true;
          currentScale = ZOOM_SCALE;
          img.style.cursor = 'zoom-out';
          img.style.transition = 'transform .25s';
          applyTransform();
        }
      });

      // Desktop mouse-wheel zoom, and Mac trackpad pinch — browsers deliver
      // a real two-finger trackpad pinch as a 'wheel' event with ctrlKey
      // set to true, so this one handler covers both regular scroll-wheel
      // zoom and genuine trackpad pinch gestures. Reuses the same
      // anchor-preserving math as the touch pinch handler, keeping the
      // point under the cursor fixed in place as the scale changes.
      imgWrap.addEventListener('wheel', function(e) {
        e.preventDefault();
        var rect = imgWrap.getBoundingClientRect();
        var cx = e.clientX - rect.left - rect.width / 2;
        var cy = e.clientY - rect.top - rect.height / 2;
        var anchorX = (cx - panX) / currentScale;
        var anchorY = (cy - panY) / currentScale;
        // Trackpad pinch deltas tend to be small and frequent; regular
        // mouse-wheel deltas are larger and coarser — this factor feels
        // natural for both without needing to distinguish the source.
        var zoomFactor = Math.exp(-e.deltaY * 0.01);
        currentScale = Math.min(Math.max(currentScale * zoomFactor, MIN_SCALE), MAX_SCALE);
        isZoomed = currentScale > 1.02;
        if (!isZoomed) {
          currentScale = 1;
          panX = 0;
          panY = 0;
        } else {
          panX = cx - anchorX * currentScale;
          panY = cy - anchorY * currentScale;
        }
        img.style.transition = 'none';
        img.style.cursor = isZoomed ? 'zoom-out' : 'zoom-in';
        applyTransform();
      }, { passive: false });

      // Mount on <html>, not <body> — this escapes any transform-based
      // scroll-lock that another script (e.g. GoKwik's cart-drawer lock)
      // might apply to <body>. If <body> has a `transform` on it,
      // position:fixed becomes relative to that transformed box instead
      // of the real viewport, which is what shrinks the overlay down to
      // a boxed-in area instead of covering the whole screen.
      document.documentElement.appendChild(overlay);
      lockBodyScroll();

      // Keep the overlay's height pinned to the *actual* visible viewport
      // as mobile browser chrome (address bar / toolbar) shows and hides.
      function __setZoomHeight() {
        var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
        overlay.style.height = vh + 'px';
      }
      __setZoomHeight();
      window.addEventListener('resize', __setZoomHeight);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', __setZoomHeight);
      overlay.__cleanupHeightListener = function () {
        window.removeEventListener('resize', __setZoomHeight);
        if (window.visualViewport) window.visualViewport.removeEventListener('resize', __setZoomHeight);
      };

      goTo(startIndex);
    }

    // Open on main image click — works on both desktop and mobile.
    // Ignores the ghost click that follows a real swipe gesture.
    mainImg.addEventListener('click', function() {
      if (gallerySwipeJustHappened) {
        gallerySwipeJustHappened = false;
        return;
      }
      openOverlay(getCurrentIndex());
    });

    // Restrict native touch handling to vertical panning only, so the browser
    // never fights the horizontal drag JS with its own scroll/bounce behavior.
    galleryMain.style.touchAction = 'pan-y';
  }

  function ping(msg) {
    var t = document.getElementById('pdp-toast');
    if (!t) return;
    t.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9DB3A0" stroke-width="2" stroke-linecap="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg> ${msg}`;
    t.classList.add('show');
    clearTimeout(window.__pdpToast);
    window.__pdpToast = setTimeout(function () { t.classList.remove('show'); }, 2800);
  }

  function initReviewFilters() {
    document.querySelectorAll('.rev-filter').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.rev-filter').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        var filter = btn.dataset.filter || 'all';
        document.querySelectorAll('.rev-card').forEach(function (card) {
          var tags = (card.dataset.useTags || '').split(',');
          card.style.display = (filter === 'all' || tags.includes(filter)) ? '' : 'none';
        });
      });
    });
  }

  function initMobileBar() {
    var mbSize = document.getElementById('pdp-mb-size');
    if (mbSize) {
      mbSize.addEventListener('click', function (e) {
        e.stopPropagation();
        var existing = document.getElementById('pdp-mb-size-dropdown');
        if (existing) { existing.remove(); return; }
        var sizeBtns = document.querySelectorAll('.size-btn');
        if (!sizeBtns.length) return;
        var dropdown = document.createElement('div');
        dropdown.id = 'pdp-mb-size-dropdown';
        dropdown.style.cssText = 'position:fixed;bottom:60px;left:0;right:0;z-index:40;background:var(--cream);border-top:1px solid var(--line);padding:14px var(--gut);display:flex;flex-wrap:wrap;gap:8px;box-shadow:0 -8px 24px rgba(0,0,0,.08);';
        var label = document.createElement('div');
        label.style.cssText = 'width:100%;font-size:11px;font-weight:600;letter-spacing:.12em;text-transform:uppercase;color:var(--ink-3);margin-bottom:4px;';
        label.textContent = 'Select Size';
        dropdown.appendChild(label);
        sizeBtns.forEach(function(btn) {
          var opt = document.createElement('button');
          opt.type = 'button';
          opt.textContent = btn.dataset.size;
          opt.disabled = btn.classList.contains('is-soldout');
          opt.style.cssText = 'min-width:50px;height:42px;padding:0 12px;background:var(--paper);border:1px solid var(--line-2);border-radius:var(--r);font-size:13.5px;font-family:var(--sans);color:var(--ink);cursor:pointer;';
          if (btn.classList.contains('is-soldout')) {
            opt.style.cssText += 'color:var(--ink-3);text-decoration:line-through;cursor:not-allowed;background:var(--sand);border-color:var(--line);';
          }
          if (btn.classList.contains('is-selected')) {
            opt.style.cssText += 'background:var(--ink);color:var(--cream);border-color:var(--ink);';
          }
          opt.addEventListener('click', function() {
            btn.click();
            dropdown.remove();
          });
          dropdown.appendChild(opt);
        });
        document.body.appendChild(dropdown);
        // Close on outside tap
        setTimeout(function() {
          document.addEventListener('click', function closeDrop(e) {
            if (!dropdown.contains(e.target) && e.target !== mbSize) {
              dropdown.remove();
              document.removeEventListener('click', closeDrop);
            }
          });
        }, 0);
      });
    }
    // Add body padding so content isn't hidden behind sticky bar on mobile
    var bar = document.getElementById('pdp-mobile-bar');
    if (bar && window.getComputedStyle(bar).display !== 'none') {
      document.body.style.paddingBottom = '60px';
    }
  }

  function initRatingLink() {
    var link = document.getElementById('pdp-rating-link');
    if (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var sec = document.getElementById('pdp-reviews');
        if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  /* =====================================================
     INLINE STARS — PARTIAL FILL
     #pdp-inline-stars (next to the fabric-quality line, near
     the title) is populated at runtime by Judge.me's external
     widget script — not by this file or by pdp-main.liquid —
     and Judge.me renders it as whole/rounded glyph stars.
     Once Judge.me has written a numeric score into
     #pdp-inline-score, rebuild #pdp-inline-stars into the
     track/fill markup (.stars-track / .stars-fill, styled in
     pdp.css) so the star display shows the true decimal
     rating (e.g. 4.8) instead of rounding to a whole star.
     ===================================================== */
  function initInlineStars() {
    var starsEl = document.getElementById('pdp-inline-stars');
    var scoreEl = document.getElementById('pdp-inline-score');
    if (!starsEl || !scoreEl) return;

    function rebuild() {
      if (starsEl.dataset.partialFill === '1') return true; // already rebuilt
      var scoreText = scoreEl.textContent.trim();
      var rating = parseFloat(scoreText);
      if (!scoreText || isNaN(rating)) return false;
      starsEl.dataset.partialFill = '1'; // set before mutating, so our own change doesn't retrigger the observer

      // Clip each star independently (0%–100%) rather than clipping one
      // 5-glyph row by an overall percentage — a row-level clip lands
      // inside a single glyph's padding and is visually invisible for
      // anything above ~4/5. Per-star clipping actually cuts the shape.
      var floorVal = Math.floor(rating);
      var frac = rating - floorVal;
      var halfFill = 0;
      if (frac >= 0.9) {
        floorVal += 1;
      } else if (frac >= 0.25) {
        halfFill = 50;
      }
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var fillPct;
        if (i <= floorVal) fillPct = 100;
        else if (i === floorVal + 1) fillPct = halfFill;
        else fillPct = 0;
        html += '<span class="star-unit" style="--star-fill:' + fillPct + '%;">' +
                  '<span class="star-track">★</span>' +
                  '<span class="star-fill">★</span>' +
                '</span>';
      }
      starsEl.innerHTML = html;
      return true;
    }

    if (rebuild()) return;

    // Judge.me fills this in asynchronously — watch both the stars element
    // and the score element until real data shows up, then rebuild once.
    var starsObserver = new MutationObserver(function () {
      if (starsEl.dataset.partialFill === '1') return; // ignore the mutation we just made
      if (rebuild()) { starsObserver.disconnect(); scoreObserver.disconnect(); }
    });
    var scoreObserver = new MutationObserver(function () {
      if (rebuild()) { starsObserver.disconnect(); scoreObserver.disconnect(); }
    });
    starsObserver.observe(starsEl, { childList: true, subtree: true, characterData: true });
    scoreObserver.observe(scoreEl, { childList: true, subtree: true, characterData: true });
  }

  /* =====================================================
     MOBILE STICKY BAR RATING
     #pdp-inline-rating (near the title) is populated at
     runtime by an external Judge.me widget script, not by
     this file or by pdp-main.liquid — so instead of relying
     on the Liquid metafield (which can lag behind Judge.me's
     live data), mirror whatever that script fills in once
     it's actually populated.
     ===================================================== */
  function initMobileBarRating() {
    var inlineRating = document.getElementById('pdp-inline-rating');
    var inlineScore  = document.getElementById('pdp-inline-score');
    var mbRating     = document.getElementById('pdp-mb-rating');
    var mbScore      = document.getElementById('pdp-mb-rating-score');
    if (!inlineRating || !inlineScore || !mbRating || !mbScore) return;

    function syncFromInline() {
      var isVisible = window.getComputedStyle(inlineRating).display !== 'none';
      var scoreText = inlineScore.textContent.trim();
      if (isVisible && scoreText) {
        mbScore.textContent = scoreText;
        mbRating.style.display = 'inline-flex';
        return true;
      }
      return false;
    }

    // Covers the case where the widget script already ran before this file did
    if (syncFromInline()) return;

    // Otherwise watch for the widget script to populate it asynchronously
    var observer = new MutationObserver(function () {
      if (syncFromInline()) observer.disconnect();
    });
    observer.observe(inlineRating, {
      attributes: true,
      attributeFilter: ['style'],
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function initPincodeInput() {
    var input = document.getElementById('pdp-pincode-input');
    var btn   = document.getElementById('pdp-pincode-btn');
    if (input) input.addEventListener('keydown', function (e) { if (e.key === 'Enter') checkPincode(); });
    if (btn)   btn.addEventListener('click', checkPincode);
  }

  function initSizeGuide() {
    var openBtn  = document.getElementById('pdp-size-guide-btn');
    var closeBtn = document.getElementById('pdp-size-modal-close');
    var overlay  = document.getElementById('pdp-size-modal');
    if (openBtn)  openBtn.addEventListener('click', openSizeGuide);
    if (closeBtn) closeBtn.addEventListener('click', closeSizeGuide);
    if (overlay)  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeSizeGuide(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSizeGuide();
    });
  }

  function initCTAs() {
    var addBtn    = document.getElementById('pdp-add-btn');
    var buyBtn    = document.getElementById('pdp-buy-btn');
    var mobAddBtn = document.getElementById('pdp-mob-add-btn');
    if (addBtn)    addBtn.addEventListener('click', addToCart);
    if (buyBtn)    buyBtn.addEventListener('click', buyNow);
    if (mobAddBtn) mobAddBtn.addEventListener('click', addToCart);
  }

  function init() {
    initGallery();
    initSizes();
    initReadMore();
    initImageZoom();
    setTimeout(initReadMore, 300);
    initAccordions();
    initSizeGuide();
    initCTAs();
    initReviewFilters();
    initMobileBar();
    initRatingLink();
    initInlineStars();
    initMobileBarRating();
    initPincodeInput();
    initRecommendations();
    updateCartCount();
    updateDispatch();
    setInterval(updateDispatch, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();


/* =====================================================
   DESKTOP GALLERY GRID → ZOOM BRIDGE — added Aug 2026
   APPEND THIS TO THE BOTTOM OF assets/pdp-test.js,
   AFTER the closing `})();` of the main IIFE.

   The grid is desktop-only. .gallery-main and .thumbs are
   hidden by CSS but still present in the DOM, so this reuses
   the existing thumb -> main-image -> overlay chain rather
   than duplicating any gallery or zoom logic:

     thumbs[i].click()  -> selectThumb(i)  (syncs src/alt/w/h)
     mainImg.click()    -> openOverlay(getCurrentIndex())

   Index parity: the .thumbs loop in pdp-main.liquid is
   `limit: 6`, and initImageZoom builds its images[] array from
   .thumb elements. The .gallery-grid loop MUST use the same
   limit, or grid item 7+ maps to an undefined thumb.
   ===================================================== */

(function () {
  'use strict';

  var grid = document.querySelector('.gallery-grid');
  if (!grid) return;

  grid.addEventListener('click', function (e) {
    var item = e.target.closest('.gallery-grid__item');
    if (!item) return;

    // Queried inside the handler, not at load — so this block works
    // whether it runs before or after the main file's init().
    var thumbs  = document.querySelectorAll('.thumbs .thumb');
    var mainImg = document.getElementById('pdp-main-image');
    if (!thumbs.length || !mainImg) return;

    var i = parseInt(item.dataset.gridIndex, 10);
    if (isNaN(i) || !thumbs[i]) return;

    thumbs[i].click();  // selectThumb(i) — syncs main image + zoom start index
    mainImg.click();    // openOverlay(getCurrentIndex())
  });

})();